import "nodelist-foreach-polyfill";

const notifications = document.getElementById("c-notifications");
const closeButtons = document.querySelectorAll<HTMLElement>(".c-notifications-close");

closeButtons.forEach((el) => {
  el.addEventListener("click", () => {
    if (notifications) {
      notifications.style.display = "none";
    }
  });
});
